import { render, staticRenderFns } from "./UploadUrlsTab.vue?vue&type=template&id=04bfd190&scoped=true&"
import script from "./UploadUrlsTab.vue?vue&type=script&lang=js&"
export * from "./UploadUrlsTab.vue?vue&type=script&lang=js&"
import style0 from "./UploadUrlsTab.vue?vue&type=style&index=0&id=04bfd190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bfd190",
  null
  
)

export default component.exports